import { render } from "./techniquesChecbox.vue?vue&type=template&id=4963d8f0"
import script from "./techniquesChecbox.vue?vue&type=script&lang=js"
export * from "./techniquesChecbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__